module.exports = __webpack_public_path__ + "static/img/indexPic7.f7f90b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexPic7.png
// module id = /Gth
// module chunks = 1